export function toPascalCaseWithSpace(inputString) {
    const words = inputString?.split(/\s+/);
    const pascalCaseWords = words && words?.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    const pascalCaseString = pascalCaseWords?.join(' ');
    return pascalCaseString;
  }